export { default } from "./SignupController";
